exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2o6yY-RL-loahqWQ4Pygl_{display:flex}\n", ""]);

// Exports
exports.locals = {
	"Week": "_2o6yY-RL-loahqWQ4Pygl_"
};